//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import WX_API from '@/utils/wx_api'
export default {
    data() {
        return {
            qr: '',
            title: ''
        }
    },
    mounted() {
        const { qr, building_name } = this.$route.query
        this.qr = decodeURIComponent(qr);
        this.title = `你好，我刚在购房通上看了${building_name}，有些问题想咨询`
    },
    methods: {
        copy() {
            this.$sendCtmEvtLog('添加置业顾问页-复制按钮点击')
            wx.showToast({
                title: '复制成功',
                icon: 'none'
            })
        }
    }
}
